import { useTranslation } from 'react-i18next'
import MaterialIcon from '../ui/MaterialIcon'
import type { ConflictAlert } from '../../lib/conflicts'

type UrgentConflictBannerProps = {
  alert: ConflictAlert
  onTap: () => void
}

const UrgentConflictBanner = ({ alert, onTap }: UrgentConflictBannerProps) => {
  const { t } = useTranslation()

  const summary =
    alert.workout && alert.calendarEvent
      ? t('coach.conflict.overlapSummary', {
          event: alert.calendarEvent.title,
          workout: alert.workout.title,
        })
      : alert.message

  return (
    <button
      type="button"
      onClick={onTap}
      className="flex w-full items-start gap-3 rounded-2xl border border-amber-500/40 bg-amber-950/40 px-4 py-3 text-left transition-colors hover:bg-amber-950/60"
    >
      <MaterialIcon name="event_busy" filled size="sm" className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-amber-400">
          {t('coach.conflict.urgentBanner')}
        </p>
        <p className="mt-1 line-clamp-2 text-sm text-amber-100/90">{summary}</p>
        <p className="mt-1 text-xs text-amber-300/80">{t('coach.conflict.tapToResolve')}</p>
      </div>
      <MaterialIcon name="chevron_right" size="sm" className="shrink-0" />
    </button>
  )
}

export default UrgentConflictBanner
